<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 100%; max-width: 100vw;':''">
    <q-card-section class="q-pa-xs">
      <q-input v-if="!$q.screen.lt.md" v-model="filter" filled  label="جستجو..." />
    </q-card-section>
    <q-card-section class="no-padding">
      <CustomerFinanceDesktop :filter="filter" v-if="!$q.screen.lt.md" :items="items" :rem-credit="remCredit" :customer-info="CustomerInfo"/>
      <CustomerFinanceMobile :filter="filter" v-if="$q.screen.lt.md" :items="items" :rem-credit="remCredit" :customer-info="CustomerInfo"/>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import CustomerFinanceDesktop from "@/components/Finance/CustomerFinanceDesktop";
import CustomerFinanceMobile from "@/components/Finance/CustomerFinanceMobile";

export default {
  name: "CustomerFinanceInfo",
  components: {CustomerFinanceMobile, CustomerFinanceDesktop},
  props: {
    CustomerInfo: {
      required: true
    }
  },
  data() {
    return {
      remCredit: '',
      items: [],
      filter:undefined
    }
  },
  methods: {
    ...mapActions({
      getCustomerFinance: 'Customers/getCustomerFinance'
    }),
  },
  created() {
    this.getCustomerFinance(this.CustomerInfo.Cs_Code).then((res) => {
      this.items = res;
      if (this.items && this.items.length>0){
        this.remCredit = this.items[this.items.length - 1].cum_sum
      }
    })
  }
}
</script>

<style scoped>

</style>